<template>
    <section class="ui-main-menu">
        <div ref="teste" class="ui-panel-menu scroll-color" :class="open ? 'active' : ''">
            <ul>
                <li v-for="(menu, index) in navigation" :key="index">
                    <button v-if="!menu.link && checkPermission(menu.allowed_to, menu.allowed_to_except) && menu.allowed" type="button" @click="openMenu(menu.id)">
                        <div class="icon">
                            <i :class="menu.icon"/>
                        </div>
                        <span :class="menu.css">{{menu.label}}</span>
                        <i class="fas fa-caret-down"/>
                    </button>
                    <router-link v-if="menu.link && checkPermission(menu.allowed_to, menu.allowed_to_except) && menu.allowed" :to="menu.link">
                        <div class="icon">
                            <i :class="menu.icon"/>
                        </div>
                        <span :class="menu.css">{{menu.label}}</span>
                        <i class="fas fa-caret-down"/>
                    </router-link>
                    <div v-if="menu.submenu" :ref="menu.id" class="submenu">
                        <section class="content">
                            <section class="navigation">
                                <div class="title">
                                    <i v-if="menu.icon" :class="menu.icon"/>
                                    <h2>{{menu.submenu.title}}</h2>
                                </div>
                                <section class="categories">
                                    <section v-for="category in menu.submenu.categories" :key="category.slug" :style="{'display': category.allowed ? 'block' : 'none'}" >
                                        <div v-if="checkPermission(category.allowed_to, category.allowed_to_except) && category.allowed">
                                            <h3>{{category.title}}</h3>
                                            <ul>
                                                <li v-for="link in category.navigation" :key="link.slug" style="cursor: pointer">
                                                    <router-link
                                                        v-if="checkPermission(link.allowed_to, link.allowed_to_except) && link.v2 && link.allowed"
                                                        :to="{ name: link.link, params: { ...link.params, funnel_id: link.id } }"
                                                        @click="clickEvent(link.event, link.modal, link.params)">
                                                        <i :class="link.icon ? link.icon : menu.icon_item"/>
                                                        {{link.label}} <span v-if="link.new">Nova</span> <span v-if="link.beta">Beta</span>
                                                    </router-link>
                                                    <a
                                                        v-else-if="checkPermission(link.allowed_to, link.allowed_to_except) && link.allowed"
                                                        :href="link.link"
                                                        @click="clickEvent(link.event, link.modal, link.params)">
                                                        <i :class="link.icon ? link.icon : menu.icon_item"/>
                                                        {{link.label}}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </section>
                                </section>
                            </section>
                            <section v-if="menu?.news" class="tutorial">
                                <div class="title">
                                    <i class="fal fa-comments-alt"/>
                                    <h2>Novidades Facilita</h2>
                                </div>
                                <div class="content">
                                    <a v-if="menu.news.cover" class="cover" :href="menu.news.cover_link" :target="menu?.news?.target ? '_' + menu?.news?.target : ''">
                                        <img :src="menu.news.cover"/>
                                    </a>
                                    <div class="text">
                                        <h3 v-if="menu?.news?.title" v-html="menu.news.title" />
                                        <p v-if="menu?.news?.text" v-html="menu.news.text" />
                                        <a v-if="menu?.news?.btn_text && menu?.news?.btn_link" :href="menu.news.btn_link" target="_blank">{{menu.news.btn_text}}</a>
                                    </div>
                                </div>
                            </section>
                        </section>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="open" class="menu-overlay" @click="closeMenu"/>
    </section>
</template>

<script>
	import helpers from '@/mixins/helpers'
	import { reserves, s3Filesystem, salesTable} from "@/services/axios"
	import { storage } from '@/services/storage'
	import { mapActions, mapGetters } from 'vuex'

	const moment = require('moment')
	require('moment/locale/pt-br')

	const broker     		= storage.get('label_broker') || 'Corretor'
	const manager    		= storage.get('label_manager') || 'Gerente'
	const supervisor 		= storage.get('label_supervisor') || 'Supervisor'

	export default {
		name: 'panel-menu',

		mixins: [ helpers ],

		data(){
			return {
				open: false,
				current: null,
				club: null,
				storageMenu: null,
				allowed_apps: null,
				preSalesStage: null,
				navigation: null,
				parcelTypeOptions: [],
			}
		},

		computed: {
			...mapGetters({
				user: 'auth/getUser',
				newMenu: 'menu/getMenu'
			}),
			dataBusiness() {
				let configs = JSON.parse(storage.get('get-configs-data'))
				return configs.dataBusiness
			},
			newMenu(){
				return JSON.parse(storage.get('painel_menu'))
			},
			user() {
				return JSON.parse(storage.get('user_logged'))
			},
		},

		// created() {
		// },

		beforeMount(){
			let clubPoints       = storage.get('club')
			this.club            = JSON.parse(clubPoints)
			this.allowed_apps    = storage.get('allowed_apps')
			this.labelSupervisor = storage.get('label_supervisor')
			this.labelManager    = storage.get('label_manager')
			this.labelBroker     = storage.get('label_broker')
			this.preSalesStage 	 = JSON.parse(storage.get('data_pre_sales')).stage
		},

		async mounted() {
			this.loadNavigationNews()
			if (this.user.user_group == 'admin') {
				await this.load()
				this.$root.$on("load-transfer-menu", payload => {
					const navigationItem = this.navigation.find(item => item.id === 'empreendimentos')
					if (navigationItem && navigationItem.submenu) {
						const categories = navigationItem.submenu.categories
						const reservasCategory = categories.find(category => category.slug === 'reservas')

						if (reservasCategory && reservasCategory.navigation) {
							const transferReservationItem = reservasCategory.navigation.find(nav => nav.slug === 'transferencia-de-reservas')

							if (transferReservationItem) {
								transferReservationItem.allowed = payload[0].active
								storage.set('transfer-reserves', JSON.stringify({ active: transferReservationItem.allowed }))
							}
						}
					}
				})
			}
			this.$root.$on("menu-toggle", () => this.closeMenu())
			salesTable.getSeries().then((response) => {
				this.parcelTypeOptions = response.data.map((item) => {
					return {
						label: item.display_name,
						value: item.parcel_type,
						...item
					}
				});
			}).catch((error) => {
				this.$toastr.e(error)
			}).finally(() => {
				this.$store.dispatch('salesTable/setSalesTableParcelTypes', this.parcelTypeOptions)
				storage.set('parcel_types', JSON.stringify(this.parcelTypeOptions))
			});
		},

		beforeDestroy() {
			this.$root.$off("menu-toggle")
		},

		methods: {
			...mapActions('menu', { setMenu: 'setMenu' }),

			async load() {
				try {
					const response = await reserves.getConfigGlobal()
					const navigationItem = this.navigation.find(item => item.id === 'empreendimentos')
					if (navigationItem && navigationItem.submenu) {
						const categories = navigationItem.submenu.categories
						const reservasCategory = categories.find(category => category.slug === 'reservas')

						if (reservasCategory && reservasCategory.navigation) {
							const transferReservationItem = reservasCategory.navigation.find(nav => nav.slug === 'transferencia-de-reservas')

							if (transferReservationItem) {
								transferReservationItem.allowed = response.data.data.global_reserves_transfer.active
								storage.set('transfer-reserves', JSON.stringify({ active: transferReservationItem.allowed }))
							}
						}
					}
				} catch (error) {
					if (error.data?.msg) {
						this.$mx_alertError(error.data.msg)
					} else {
						this.$mx_alertError(error)
					}
				}
			},
			setNewMenu () {
				this.setMenu({ navigation: this.navigation })
			},
			openMenu(id){
				let el = this.$refs[id][0]
				if(el.classList.contains('active')){
					el.classList.remove('active')
				}else{
					if(this.current){
						this.$refs[this.current][0].classList.remove('active')
					}
					el.classList.add('active')
				}
				this.current = id
				this.open = true
			},
			closeMenu(){
				this.open = !this.open
			},
			checkPermission(allowedTo = [], allowedToExcept = []){
				/** Verifica se o menu pode ser mostrado para todos, exceto para algumas classes */
				if (allowedToExcept.length && allowedToExcept.includes(this.user?.user_group)) {
					return false
				}

				if(allowedTo.length === 0 || allowedTo.includes('dinamic') && this.user?.isDynamicGroup){
					return true
				}
				/** Verifica se o menu pode ser mostrado para todos, ou apenas para algumas classes */
				if (allowedTo.length === 0 || allowedTo.includes(this.user?.user_group)){
					return true
				}

				return false
			},
			checkMenuAllowed(name){
				const allowedMenu= storage.get('allowed_menu')
				return allowedMenu.includes(name)
			},
			checkAppsAllowed(name){
				return this.allowed_apps.includes(name)
			},
			/**
				* Verifica se existe uma configuração de evento de clique para o menu e,
				* caso exista, emite o evento
			*/
			clickEvent(event, modal, params) {
				if (event && Object.keys(event).length) this.$gtm.trackEvent(event)
				if (modal) this.$root.$emit('modal-open-' + modal, params)
			},
			/**
			 * Associa as informações de novidades aos respectivos menus
			 */
			setNewsMenu(response) {
				const getStorage = JSON.parse(storage.get('api_config'))
				const instance = getStorage.instance
				let news = []
				if (response.items && Object.prototype.hasOwnProperty.call(response.items, 'length')) {
					news = [...response.items]
				}

                let navigation = this.setNavigation()

				navigation.map(menu => {
					/**
					 * se estiver dentro do tempo do time
					 * e se for somente algumas instancias
					 * ou todas as instancias menos algumas selecionadas
					 * e se tiver no grupo selecionado
					 * e se tiver no plano e no segmento
					 * ativa o anuncio dentro do menu setado
					*/
					menu.news = news.find(item => item.show_in_menu == menu.id &&
						moment().isSameOrAfter(moment(item.start_time, 'DD/MM/YYYY HH:mmA')) && 				//se estiver dentro do tempo do time
						moment().isSameOrBefore(moment(item.end_time, 'DD/MM/YYYY HH:mmA')) &&  				//se estiver dentro do tempo do time

						(!item.instances.includes('all') && this.compareIntances(item, instance) || 			//e se for somente algumas instancias
						item.instances.includes('all') && this.compareNotInstances(item, instance)) &&  		//ou todas as instancias menos algumas selecionadas

						( this.dataBusiness && item.flat.includes(this.dataBusiness.plano) &&											//e se tiver no plano e no segmento
						item.segment.includes(this.dataBusiness.segmento) ||
						(item.segment.includes('all') && !item.segment.includes(this.dataBusiness.segmento))) && //e se tiver no plano e no segmento

						(!item.user_role || item.user_role.includes(this.user.user_group))						//e se tiver no grupo selecionado
					)
				})
				return navigation
            },
			analiseTime(now, before) {
                return now.diff(before, 'minutes')
            },
			compareIntances(a, b) {
				return a.instances.includes(b)
			},
			compareNotInstances(a, b ) {
				return !a.instances.includes(b)
			},
			loadNavigationNews() {
				const newsMenu 	= JSON.parse(storage.get('news-menu'))
				const analises = newsMenu ? this.analiseTime(moment(), moment(newsMenu.time)) : null
				return this.getApi(analises && analises == 0 || analises < 30 ? newsMenu : null)
			},
			/**
			 * Carrega as informações de novidades a partir do arquivo na S3 e os configura
			 * nos menus
			 */
			getApi(hasNews) {
				if(hasNews) {
					this.navigation = this.setNewsMenu(hasNews.items)
					this.setNewMenu()
				} else {
					s3Filesystem.getNewsMenu()
						.then(response => {
							storage.set('news-menu', JSON.stringify({ time: moment(), items: response.data }))
							return this.navigation = this.setNewsMenu(response.data)

						}).catch(error => {
							console.error(error)
						})
				}

			},
			setNavigation() {
				let navigation = [
					{
						label: 'Vendas',
						link: false,
						id: 'vendas',
						css: 'menu-vendas menu-item',
						icon: 'fal fa-handshake-alt',
						icon_item: 'fas fa-caret-right',
						allowed: this.checkMenuAllowed('clientes') || this.checkMenuAllowed('propostas') || this.checkMenuAllowed('reservas'),
						allowed_to: [],
						allowed_to_except: [],
						submenu: {
							title: 'Vendas',
							open: false,
							categories: [
								{
									title: 'Funil',
									slug: 'funil',
									allowed: true,
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Funil de Pré-Atendimento',
											v2: true,
											beta: false,
											link: 'sales.deals.funnel.pre',
											params: {
												id: this.preSalesStage
											},
											slug: 'pre-funil-de-vendas-new',
											allowed: this.checkMenuAllowed('funnel_view_pre_attendance') && this.preSalesStage,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Funil de Vendas',
											v2: true,
											beta: false,
											link: 'sales.deals.funnel',
											slug: 'funil-de-vendas-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
									]
								},
								{
									title: 'Clientes',
									slug: 'clientes',
									allowed: this.checkMenuAllowed('clientes'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										// {
										// 	label: 'Funil de Pré-Atendimento',
										// 	v2: true,
										// 	beta: false,
										// 	link: 'sales.deals.funnel.pre',
										// 	params: {
										// 		id: this.preSalesStage
										// 	},
										// 	slug: 'pre-funil-de-vendas-new',
										// 	allowed: this.checkMenuAllowed('funnel_view_pre_attendance') && this.preSalesStage,
										// 	allowed_to: [],
										// 	allowed_to_except: [],
										// },
										// {
										// 	label: 'Funil de Vendas',
										// 	v2: true,
										// 	beta: false,
										// 	link: 'sales.deals.funnel',
										// 	slug: 'funil-de-vendas-new',
										// 	allowed: true,
										// 	allowed_to: [],
										// 	allowed_to_except: [],
										// },
										{
											label: 'Listar Clientes',
											v2: true,
											new: false,
											link: 'sales.deals.list',
											slug: 'listar-clientes-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Cadastrar Cliente',
											modal: 'create-deal-modal',
											slug: 'cadastrar-cliente',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Configurações',
											v2: true,
											new: false,
											link: 'configurations.customers',
											slug: 'configurations-customers',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
									]
								},
								{
									title: 'Propostas',
									slug: 'propostas',
									allowed: this.checkMenuAllowed('propostas'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Lista de Propostas',
											v2: true,
											new: false,
											link: 'sales.proposal.list',
											slug: 'lista-de-propostas-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Proposta',
											modal: 'create-deal-modal',
											params: 'createProposal',
											slug: 'criar-proposta',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Configurações',
											v2: true,
											new: false,
											link: 'configurations.proposal',
											slug: 'configurations-proposal',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										}
									]
								},
								{
									title: 'Reservas',
									slug: 'reservas',
									allowed: this.checkMenuAllowed('reservas'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Reservas',
											v2: true,
											new: false,
											link: 'sales.reservations.list',
											slug: 'listar-reservas-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Reserva',
											slug: 'criar-reserva',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
											modal: 'global--request-reserve'
										},
										{
											label: 'Configurações',
											v2: true,
											new: false,
											link: 'configurations.reserves',
											slug: 'configurations-reserves',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										}
									]
								},
								{
									title: 'Contratos',
									slug: 'configuracoes',
									allowed: this.checkMenuAllowed('contract'),
									allowed_to: ['admin', 'collaborator', 'dinamic'],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Gerador de Documentos e Contratos',
											v2: true,
											link: 'sales.integrations.contractGeneration', //this.getUrl('vendas/configuracao/geracao-de-contratos'),
											slug: 'geracao-de-contratos',
											allowed: true,
											allowed_to: ['admin', 'collaborator', 'dinamic'],
											allowed_to_except: []
										},
									]
								}
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
					{
						label: 'Empreendimentos',
						link: false,
						id: 'empreendimentos',
						css: 'menu-empreendimentos menu-item',
						icon: 'fal fa-building',
						icon_item: 'fas fa-caret-right',
						allowed: this.checkMenuAllowed('empreendimentos'),
						allowed_to: [],
						allowed_to_except: [],
						submenu: {
							title: 'Empreendimentos',
							open: false,
							categories: [
								{
									title: 'Empreendimentos',
									slug: 'empreendimentos',
									allowed: this.checkMenuAllowed('empreendimentos'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Empreendimentos',
											v2: true,
											new: false,
											link: 'products.list',
											slug: 'listar-empreendimentos-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},

										{
											label: 'Cadastrar Empreendimento',
											link: this.oldPanelLink('empreendimentos/etapa1'),
											slug: 'cadastrar-empreendimento-new',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
											event: {
												event: "fac_button_click",
												category: "vuejs-cadastrar empreendimento",
												action: "click",
												label: "Cadastrar empreendimento a partir do menu header"
											}
										},
										{
											label: 'Gerenciar Categorias',
											link: this.oldPanelLink('empreendimentos/categorias'),
											slug: 'gerenciar-categorias',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},

									]
								},
								{
									title: 'Reservas',
									slug: 'reservas',
									allowed: this.checkMenuAllowed('reservas'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Reservas',
											v2: true,
											new: false,
											link: 'sales.reservations.list',
											slug: 'listar-reservas-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Reserva',
											slug: 'criar-reserva',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
											modal: 'global--request-reserve'
										},
										{
											label: 'Transferência de Reservas',
											slug: 'transferencia-de-reservas',
											allowed: false,
											allowed_to: [],
											allowed_to_except: [],
											v2: true,
											new: false,
											link: 'transfer.reservations',
										},
									]
								},
								{
									title: 'Lançamentos',
									slug: 'lancamentos',
									allowed: this.checkMenuAllowed('lancamentos'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Gerenciar Lançamento',
											v2: true,
											link: 'launch.management.list',
											slug: 'gerenciar-lancamento',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Abrir Lançamento',
											link: 'launch.management.computerServicePoint',
											v2: true,
											slug: 'abrir-lancamento',
											allowed: true,
											allowed_to: [],
											allowed_to_except: []
										},
									]
								},
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/tutoriais/saiba-mais',
						// }
					},
					{
						label: 'Atendimento',
						link: false,
						id: 'atendimento',
						css: 'menu-atendimento menu-item',
						icon: 'fal fa-comment-alt-lines',
						icon_item: 'fas fa-caret-right',
						allowed: this.checkMenuAllowed('tarefas') || this.checkMenuAllowed('chat'),
						allowed_to: [],
						allowed_to_except: [],
						submenu: {
							title: 'Atendimento',
							open: false,
							categories: [
								{
									title: 'Tarefas',
									slug: 'tarefas',
									allowed: this.checkMenuAllowed('tarefas'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Tarefas',
											link: this.oldPanelLink('vendas/clientes/tarefas'),
											slug: 'listar-tarefas',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Tarefa',
											slug: 'criar-tarefa',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
											modal: 'global--create-task',
											event: {
												event: "fac_button_click",
												category: "vuejs-criar tarefa",
												action: "click",
												label: "Criar tarefa a partir do menu header"
											}
										}
									]
								},
								{
									title: 'Chat',
									slug: 'chat',
									allowed: this.checkMenuAllowed('chat'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Acessar Chat',
											link: this.oldPanelLink('chat'),
											slug: 'acessar-chat',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
									]
								},
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
					{
						label: 'Marketing',
						link: false,
						id: 'marketing',
						css: 'menu-marketing menu-item',
						icon: 'fal fa-bullseye-pointer',
						icon_item: 'fas fa-caret-right',
						allowed: this.checkMenuAllowed('leads') || this.checkMenuAllowed('integrações'),
						allowed_to: [],
						allowed_to_except: ['manager', 'supervisor', 'broker'],
						submenu: {
							title: 'Marketing',
							open: false,
							categories: [
								{
									title: 'Distribuição de Leads',
									slug: 'distribuição-de-leads',
									allowed: this.checkMenuAllowed('leads'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Filas',
											new: false,
											v2: true,
											link: 'marketing.queues.list',
											slug: 'listar-filas-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Fila',
											v2: true,
											link: 'marketing.queues.add',
											slug: 'criar-fila',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
											event: {
												event: "fac_button_click",
												category: "vuejs-criar fila marketing",
												action: "click",
												label: "Cadastrar fila a partir do menu header"
											}
										},
									]
								},
								{
									title: 'Integrações',
									slug: 'integrations',
									allowed: this.checkMenuAllowed('integrações'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Integrações',
											link: this.oldPanelLink('configuracao/apps'),
											slug: 'listar-filas',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['manager', 'supervisor', 'broker'],
										}
									]
								},
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
					{
						label: 'Comunicação',
						link: false,
						id: 'comunicacao',
						css: 'menu-comunicacao menu-item',
						icon: 'fal fa-comment-alt-smile',
						icon_item: 'fas fa-caret-right',
						allowed_to: [],
						allowed_to_except: [],
						allowed: this.checkMenuAllowed('novidades') || this.checkMenuAllowed('agenda'),
						submenu: {
							title: 'Comunicação',
							open: false,
							categories: [
								{
									title: 'Novidades',
									slug: 'novidades',
									allowed: this.checkMenuAllowed('novidades'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Novidades',
											link: 'news.list',
											slug: 'listar-novidades-new',
											v2: true,
											new: false,
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Gerenciar Categorias',
											link: this.oldPanelLink('noticias/categorias'),
											slug: 'gerenciar-categoria',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Criar Novidade',
											link: 'news.add',
											slug: 'criar-novidade-new',
											v2: true,
											new: false,
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
									]
								},
								{
									title: 'Eventos',
									slug: 'eventos',
									allowed: this.checkMenuAllowed('agenda'),
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Listar Eventos',
											link: this.oldPanelLink('eventos'),
											slug: 'listar-eventos',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Criar Evento',
											link: this.oldPanelLink('eventos/adicionar'),
											slug: 'criar-evento',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Listar Locais',
											link: this.oldPanelLink('locais'),
											slug: 'listar-locais',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},

									]
								},
							]
						},
					},

					{
						label: 'Relatórios',
						link: false,
						id: 'relatorios',
						css: 'menu-relatorios menu-item',
						icon: 'fal fa-chart-pie-alt',
						icon_item: 'fas fa-caret-right',
						allowed: this.checkMenuAllowed('powerbi') || this.checkMenuAllowed('reportExcel'),
						allowed_to: [
							'admin',
							'collaborator',
							'supervisor',
							'broker',
							'manager',
							'powerbi'
						],
						allowed_to_except: [],
						submenu: {
							title: 'Relatórios',
							open: false,
							categories: [
								{
									title: 'Relatórios em Planilhas',
									slug: 'relatorios-em-planilhas',
									allowed: this.checkMenuAllowed('planilhas'),
									allowed_to: [
										'admin',
										'collaborator',
										'supervisor',
										'manager',
										'powerbi'
									],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Visualizar Relatórios',
											v2: true,
											beta: false,
											link: 'reports.basics.all',
											slug: 'visualizar-relatorios-excel-new',
											allowed: true,
											allowed_to: ['admin'],
											allowed_to_except: [],
										},
									]
								},
								{
									title: 'Relatórios BI',
									slug: 'relatorios-bi',
									allowed: this.checkMenuAllowed('powerbi'),
									allowed_to: [
										'admin',
										'collaborator',
										'supervisor',
										'broker',
										'manager',
										'powerbi'
									],
									allowed_to_except: [],
									navigation: []
								},
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
					{
						label: this.club.name,
						link: false,
						id: 'clube-de-pontos',
						css: 'menu-clube-de-pontos menu-item',
						icon: 'fal fa-trophy-alt',
						icon_item: 'fas fa-caret-right',
						allowed: this.club.status === 'active',
						allowed_to: [],
						allowed_to_except: [],
						submenu: {
							title: 'Clube de Pontos',
							open: false,
							categories: [
								{
									title: 'Prêmios',
									slug: 'premios',
									allowed: true,
									allowed_to: [],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Lista de Prêmios',
											link: this.oldPanelLink('clube/premios/listar'),
											slug: 'vistualizar-relatorios',
											allowed: true,
											allowed_to: [],
											allowed_to_except: [],
										},
										{
											label: 'Entrega de Prêmios',
											link: this.oldPanelLink('clube/resgates/pendentes'),
											slug: 'entrega-premios',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Resgates',
											link: this.oldPanelLink('clube/resgates/aguardando'),
											slug: 'resgates',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Ranking',
											link: this.oldPanelLink('clube/ranking'),
											slug: 'ranking',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
									]
								},
								{
									title: 'Configurações',
									slug: 'configuracoes',
									allowed: true,
									allowed_to: ['admin', 'collaborator'],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Regulamento',
											link: this.oldPanelLink('clube/regulamento'),
											slug: 'regulamento',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Configurações',
											v2: true,
											new: false,
											link: 'configurations.club',
											slug: 'configurations-club',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
									]
								},

							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
					{
						label: 'Usuários',
						link: false,
						id: 'usuarios',
						css: 'menu-usuarios menu-item',
						icon: 'fal fa-user',
						icon_item: 'fas fa-caret-right',
						allowed: true,
						allowed_to: [],
						allowed_to_except: ['broker'],
						submenu: {
							title: 'Usuários',
							open: false,
							categories: [

								{
									title: 'Equipes',
									slug: 'equipes',
									allowed: true,
									allowed_to: [],
									allowed_to_except: ['broker'],
									navigation: [
										{
											label: 'Listar Equipes',
											v2: true,
											new: false,
											link: 'users.teams',
											slug: 'listar-equipes-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['supervisor', 'manager', 'broker'],
										},
										{
											label: supervisor,
											v2: true,
											new: false,
											link: 'users.supervisors',
											slug: 'listar-supervisores-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['supervisor', 'manager', 'broker'],
										},
										{
											label: manager,
											v2: true,
											new: false,
											link: 'users.managers',
											slug: 'listar-gerentes-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['manager', 'broker'],
										},
										{
											label: broker,
											v2: true,
											new: false,
											link: 'users.brokers',
											slug: 'listar-brokers-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['broker'],
										},
										{
											label: 'Inativos',
											v2: true,
											new: false,
											link: 'users.inactives',
											slug: 'listar-inativos-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['supervisor', 'manager', 'broker'],
										},
									]
								},
								{
									title: 'Usuários',
									slug: 'usuarios',
									allowed: true,
									allowed_to: [],
									allowed_to_except: ['broker', 'manager', 'supervisor'],
									navigation: [
										{
											label: 'Listar Usuários',
											v2: true,
											new: false,
											link: 'users.list',
											slug: 'listar-usuarios-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['supervisor', 'manager', 'broker'],
										},
										{
											label: 'Cadastrar Usuário',
											v2: true,
											new: false,
											link: 'users.list',
											params: {
												new: 'novo'
											},
											slug: 'cadastrar-usuario-new',
											allowed: true,
											allowed_to: [],
											allowed_to_except: ['collaborator', 'supervisor', 'manager', 'broker'],
											event: {
												event: "fac_button_click",
												category: "vuejs-usuario",
												action: "click",
												label: "Abre o modal de cadastro de usuario a partir do menu header"
											}
										},
									]
								},
								{
									title: 'Configurações',
									slug: 'configuracoes',
									allowed: true,
									allowed_to: ['admin', 'collaborator'],
									allowed_to_except: [],
									navigation: [
										{
											label: 'Perfis de Dinâmicos',
											v2: true,
											new: false,
											link: 'configurations.users.dynamics',
											slug: 'configurations-users-dynamics',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
										{
											label: 'Configurações Gerais',
											v2: true,
											new: false,
											link: 'configurations.users.groups',
											slug: 'configurations-users-groups',
											allowed: true,
											allowed_to: ['admin', 'collaborator'],
											allowed_to_except: [],
										},
									]
								},
							]
						},
						// tutorial: {
						//     title: 'Descubra como criar um funil de vendas eficiente.',
						//     text: 'O app Facilita oferece a tecnologia para integrar processos e pessoas. Digitalize seu processo de vendas.',
						//     cover: '',
						//     btnText: 'Saiba mais',
						//     btnUrl: '/',
						// }
					},
				]
					return navigation
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>
